import { render, staticRenderFns } from "./ServiceGallery.vue?vue&type=template&id=4f0eec41"
import script from "./ServiceGallery.vue?vue&type=script&lang=ts"
export * from "./ServiceGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports